import React from "react";
import { ResponsiveBar } from "@nivo/bar";
const RoundedBarLabels = ({ bars }) => {
  return (
    <g style={{ pointerEvents: "none" }}>
      {bars.map((bar) => {
        // Skip non-conforming bars
        if (bar.data.id === "non_conforming_percent") return null;

        // Skip if value is zero or bar is empty
        if (!bar.data.value || bar.width === 0 || bar.height === 0) return null;

        const labelText = `${Math.abs(bar.data.value)}%`;
        const labelX = bar.x + bar.width / 2;
        const labelY = bar.y + bar.height / 2;

        // DYNAMIC X-AXIS PADDING (75% of the actual bar width)
        const badgeWidth = bar.width * 0.75;
        const badgeHeight = 20;

        return (
          <g key={bar.key} transform={`translate(${labelX}, ${labelY})`}>
            <rect
              x={-badgeWidth / 2}
              y={-badgeHeight / 2}
              width={badgeWidth}
              height={badgeHeight}
              rx={6}
              ry={6}
              fill="rgba(255, 255, 255, 0.55)"
            />
            <text
              textAnchor="middle"
              dominantBaseline="central"
              style={{
                fontSize: "12px",
                fontWeight: 600,
                fontFamily: "sans-serif",
                fill: "#1a1a1a",
              }}
            >
              {labelText}
            </text>
          </g>
        );
      })}
    </g>
  );
};

export const ClaimsActivityBarChart = ({ data }) => {
  return (
    <>
      <ResponsiveBar
        data={data}
        keys={["conforming_percent", "non_conforming_percent"]}
        indexBy="time"
        groupMode="stacked"
        margin={{ top: 50, right: 0, bottom: 50, left: 40 }}
        padding={0.5}
        minValue={0}
        maxValue={100}
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={["#3246d3", "#e91e63"]}
        enableLabel={false}
        layers={["grid", "axes", "bars", RoundedBarLabels, "markers", "legends"]}
        theme={{
          labels: {
            text: {
              fontSize: "12px",
              fontWeight: 600,
              fontFamily: "sans-serif",
              filter: "url(#label-background-box)",
            },
          },
        }}
        legends={[
          {
            dataFrom: "keys",
            anchor: "top-left",
            direction: "row",
            justify: false,
            translateX: -40,
            translateY: -40,
            itemsSpacing: 20,
            itemWidth: 80,
            itemHeight: 20,
            itemDirection: "left-to-right",
            itemOpacity: 0.85,
            symbolSize: 12,
            symbolShape: "circle",
            data: [
              {
                id: "conforming_percent",
                label: "Conforming",
                color: "#3246d3",
              },
              {
                id: "non_conforming_percent",
                label: "Non-Conforming",
                color: "#e91e63",
              },
            ],
            effects: [
              {
                on: "hover",
                style: {
                  itemOpacity: 1,
                },
              },
            ],
          },
        ]}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          tickValues: [0, 20, 40, 60, 80, 100],
          legend: "",
          legendPosition: "middle",
          legendOffset: 0,
          format: (value) => `${value}%`,
        }}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "",
          legendPosition: "middle",
          legendOffset: 36,
          format: (value) => {
            const [month, year] = value.split("-");
            const date = new Date(year, parseInt(month, 10) - 1, 1);
            return date.toLocaleString("default", { month: "short" });
          },
        }}
        tooltip={({ id, value, color }) => (
          <div
            style={{
              padding: "6px 10px",
              background: "#fff",
              border: `1px solid ${color}`,
              borderRadius: "4px",
              fontSize: "13px",
            }}
          >
            <strong>{id === "conforming_percent" ? "Conforming" : "Non-Conforming"}:</strong>{" "}
            {Math.abs(value)}%
          </div>
        )}
      />
    </>
  );
};
